import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null); // null = checking, false = none, object = logged in
  const [token, setToken] = useState(localStorage.getItem("an_token") || null);

  useEffect(() => {
    if (!token) { setAdmin(false); return; }
    api.get("/auth/me")
      .then((r) => setAdmin(r.data))
      .catch(() => { localStorage.removeItem("an_token"); setToken(null); setAdmin(false); });
  }, [token]);

  const login = (tok, user) => {
    localStorage.setItem("an_token", tok);
    setToken(tok);
    setAdmin(user);
  };
  const logout = () => {
    localStorage.removeItem("an_token");
    setToken(null);
    setAdmin(false);
  };

  return (
    <AuthContext.Provider value={{ admin, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
